import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'

const taskDetailSearchSchema = z.object({
  // Board category of the item ('manual' for native tasks, 'remediation',
  // 'policy_approval', … for projected items sharing this detail surface).
  category: z.string().optional().default('manual'),
  source: z.enum(['finding']).optional(),
})

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tasks_/$taskId',
)({
  validateSearch: taskDetailSearchSchema,
  staticData: {
    pageHeader: { title: 'Task', customHeader: true, pad: false },
  },
})
